<template>
  <div>
    <div class="content stationInfo">
      <div class="title">
        <div>在线投稿系统</div>
        <div>
          <span>{{ userInfo.name }}</span>
          <span
            style="color: #278dfe; margin-left: 10px; cursor: pointer"
            @click="logout"
            >【退出】</span
          >
        </div>
      </div>
      <el-page-header @back="goBack" content="站内信息"> </el-page-header>
      <ul>
        <li
          style="height: 82px; overflow: hidden"
          v-for="(item, index) in messList"
          :key="index"
          class="checkLi"
        >
          <div class="checkContent">
            {{ item.title }}
          </div>
        </li>
      </ul>

      <div class="checkAll_page">
        <div></div>
        <div class="fenye">
          <el-pagination
            class="leftPage"
            background
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-size="pageSize"
            :total="totalSize"
            layout="slot, prev"
          >
            <span
              style="
                font-size: 12px;
                color: #6b6b6b;
                line-height: 34px;
                margin-right: 15px;
              "
              >共<b>{{ totalPage }}</b
              >页</span
            >
            <el-button
              :disabled="firstPageBtnDisabled"
              id="first-pager"
              @click="toFirstPage"
            >
              << 首页</el-button
            >
          </el-pagination>
          <el-pagination
            background
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-size="pageSize"
            :total="totalSize"
            layout="pager, next, slot, jumper"
          >
            <el-button
              :disabled="lastPageBtnDisabled"
              id="first-pager"
              @click="toLastPage"
              >>> 末页</el-button
            >
          </el-pagination>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      infomationList: [],
      pageSize: 10, // 每页条数
      pageIndex: 1, // 当前页
      totalSize: 0, // 总条数
      totalPage: 0,
      firstPageBtnDisabled: true,
      lastPageBtnDisabled: false,
      lastPageNum: 0, // 尾页是多少
      messList: [],
      isCheckedAll: false,
      fruitIds: [],
      userInfo: null,
    };
  },
  created() {
    let sessionUser = JSON.parse(sessionStorage.getItem("user"));
    if (sessionUser) {
      this.userInfo = sessionUser;
    }
    this.getAllMessage();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 当前页
    currentChangeHandle(val) {
      if (val > 1) {
        this.firstPageBtnDisabled = false;
      } else if (val === this.totalPage) {
        this.lastPageBtnDisabled = true;
      }
      this.pageIndex = val;
      this.getAllMessage();
    },
    // 首页
    toFirstPage() {
      this.pageIndex = 1;
      this.lastPageBtnDisabled = false;
      this.firstPageBtnDisabled = true;
    },
    // 尾页
    toLastPage() {
      this.pageIndex = this.totalPage;
      this.lastPageBtnDisabled = true;
      this.firstPageBtnDisabled = false;
    },

    // 所有消息
    getAllMessage() {
      this.$http({
        url: "/api/infomation/list",
        method: "get",
        params: this.$http.adornParams({
          pageNo: this.pageIndex,
          length: this.pageSize,
          type: "znxx",
        }),
      })
        .then((response) => {
          let { code, data } = response.data;
          if (code === "1") {
            this.messList = data.recordList;
            this.totalSize = data.totalRow;
            this.totalPage = data.totalPage;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 退出
   logout() {
      this.$confirm("确认退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //确认退出后 删除浏览器cookie,删除token状态,返回至登录页.
          this.$http({
            url: "/api/loginOut",
            method: "get",
            params: this.$http.adornParams({}),
          })
            .then((response) => {
              let { code, data } = response.data;
              if (code === "1") {
                this.$cookie.delete("magazineToken");
                this.$store.commit("SET_TOKEN", "");
                this.$router.replace("/magaZineLogin");
                sessionStorage.removeItem("webTableSwitch");
              } else {
                this.$cookie.delete("magazineToken");
                this.$store.commit("SET_TOKEN", "");
                this.$router.replace("/magaZineLogin");
                sessionStorage.removeItem("webTableSwitch");
              }
            })
            .catch((err) => console.log(err));
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss">
.stationInfo {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000000;
  }
  .checkLi {
    .input-checkbox {
      margin: 41px 0 0 13px;
    }
  }
}
.input-checkbox:checked::after {
  background-color: red;
  color: black;
}
</style>
<style lang="scss" scoped>
.el-checkbox {
  float: left;
  margin: 41px 0 0 13px;
}

.el-page-header {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 30px;
}

.checkContent {
  width: 100%;
  height: 52px;
  line-height: 26px;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 4px;
  word-wrap: break-word;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin: 25px 0 0 0;
  text-indent: 24px;
}

.deleteCheck {
  width: 96px;
  height: 40px;
  background-color: #ffffff;
  border: 1px solid #eaeaea;
  cursor: pointer;
  outline: none;
  margin-top: -4px;
  border-radius: 5px;
}
</style>